export let MediaResolutions = [
    {key: "240p", width: 320, height: 240, label: "240p", bitrate: 384},
    {key: "360p", width: 480, height: 360, label: "360p", bitrate: 448},
    {key: "480p", width: 640, height: 480, label: "480p", bitrate: 512},
    {key: "720p", width: 960, height: 720, label: "720p", bitrate: 768},
    {key: "720hd", width: 1280, height: 720, label: "720hd", bitrate: 1024}
];

export default class MediaConstraints {
    constructor(media_constraints) {
        this.constraints = {};
        this.video_bitrate = 512;
        this.audio_bitrate = 128;
        this.reencode = false;

        this.set_minimal_video_quality(320, 240);
        this.set_maximal_video_quality(640, 480);
        

        if (media_constraints) {
            if (media_constraints.video_bitrate) {
                this.video_bitrate = media_constraints.video_bitrate;
                delete media_constraints.video_bitrate;
            }
            if (media_constraints.audio_bitrate) {
                this.audio_bitrate = media_constraints.audio_bitrate;
                delete media_constraints.audio_bitrate;
            }
            this.reencode = media_constraints.reencode ? true: false;
            delete media_constraints.reencode;

            this.constraints = media_constraints;
        }


        return this;
    }
    
    get() {
        return this.constraints;
    }

    get_without_devices() {
        // Let's copy constraints
        let constraints = JSON.parse(JSON.stringify(this.constraints));

        for (let k in constraints) {
            delete constraints[k]['deviceId'];
        }

        return constraints;
    }

    set_device_id(section, value) {
        return this.set_constraint(section, "deviceId", {"exact": value});
    }

    set_preferred_video_quality(width, height) {
        return this.set_video_quality("ideal", width, height);
    }

    set_minimal_video_quality(width, height) {
        return this.set_video_quality("min", width, height);
    }

    set_maximal_video_quality(width, height) {
        return this.set_video_quality("max", width, height);
    }

    set_video_quality(kind, width, height) {
        if (! (this.constraints.video instanceof Object) )  {
            this.constraints.video = {};
        }

        if (! (this.constraints.video.width instanceof Object) )  {
            this.constraints.video.width = {};
            this.constraints.video.height = {};
        }

        this.constraints.video.width[kind] = width;
        this.constraints.video.height[kind] = height;

        return this;
    }

    set_resolution(resolution) {
        if (this.check_resolution(resolution)) {
            this.set_preferred_video_quality(resolution.width, resolution.height);
            this.video_bitrate = resolution.bitrate;
        }

        return this;
    }

    set_constraint(section, name, value) {
        if (! (this.constraints[section] instanceof Object) )  {
            this.constraints[section] = {};
        }
        this.constraints[section][name] = value;

        return this;
    }

    enable_audio_processing(value) {
        this.set_echo_cancellation(value);
        this.set_noise_suppression(value);

        return this;
    }

    set_noise_suppression(value) {
        return this.set_constraint("audio", "noiseSuppression", value);
    }

    set_echo_cancellation(value) {
        return this.set_constraint("audio", "echoCancellation", value);
    }

    set_echo_cancellation_type(value) {
        return this.set_constraint("audio", "echoCancellationType", value);
    }

    set_auto_gain_control(value) {
        return this.set_constraint("audio", "autoGainControl", value);
    }

    check_resolution(r) {
        let v = this.constraints.video;
       
        return (v.width.min <= r.width) && (r.width <= v.width.max) &&
               (v.height.min <= r.height) && (r.height <= v.height.max);
    }

    filter_resolutions(resolutions) {
        return resolutions.filter(this.check_resolution.bind(this));
    }
}



// WEBPACK FOOTER //
// ./src/constraints.js